const ERROR_CODE_PREFIX = "ERROR_CODE_";

/**
 * @param {string} errorCode
 */
export default function (errorString) {
    const errorCode = parseInt(errorString.replace(ERROR_CODE_PREFIX, ""));

    // fallthrough is intentional
    switch (errorCode) {
        // Can be thrown when user does not accept app permissions
        case 420:
            return "Microsoft SSO sign-in Cancelled";

        // User is valid SSO user but is not registered in Pagabo Group
        case 431:
        // User is valid SSO user but is not registered in the specific product he is trying to access
        // allow-fallthrough
        case 432:
            return "Your login details are incorrect";

        // Invalid domain calling the endpoint, check if `domains` table record is
        // correct on seal
        case 520:
        // Thrown when a target entity is not found.
        // allow-fallthrough
        case 404:
            return "Something went wrong, please try again later";
        default:
            return "Something went wrong, please try again later";
    }
}
